export default {
  desktop_access:
    'Mobile Access Required<br/><br/>For a seamless Bitcash Wallet experience, please switch to your mobile device. We recommend using the latest version of your mobile browser.<br/><br/> Supported browsers include',
  desktop_access_2:
    'For full compatability and security, keep your browser and mobile device up to date.',
}
